<template>
  <v-card>
    <v-card-text>
      <v-row>
        <v-col>
          {{ $t("audit.auditStatus.lastEdit") }}
          {{
            new Date(lastEdit).toLocaleString(undefined, {
              timeZone: "CET",
            })
          }}
        </v-col>

        <v-col>
          {{ $t("audit.auditStatus.responses") }}
          {{ auditorResponses }}
        </v-col>

        <v-col>
          {{ $t("audit.auditStatus.progress") }}
          {{ progress }}/{{ total }}
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { reduce, max, propEq, filter, length, includes } from "ramda";

export default {
  props: {
    requirements: {
      type: Array,
      required: true,
    },
  },

  computed: {
    lastEdit() {
      return reduce((acc, curr) => max(acc, curr.updatedAt), this.requirements[0].updatedAt, this.requirements);
    },

    auditorResponses() {
      return length(filter(propEq("state", "EDIT"), this.requirements));
    },

    total() {
      return length(this.requirements);
    },

    progress() {
      return length(filter((req) => includes(req.state, ["DONE", "EDIT"]), this.requirements));
    },
  },
};
</script>
